import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@thecvlb/design-system/lib/tailwind.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("index.html is missing #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
